import React from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import TimePicker from "../../../../common/TimePicker";
import TextInput from "../../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import {
  PICKLIST_GROUP_NAME,
  QME_APPOINTMENT_STATUS,
} from "../../../../common/Constant";
import {
  addQMEScheduleDetails,
  fetchInjuryListDetails,
  fetchInterpreterListDetails,
  fetchPickListByGroupName,
  fetchQMEDoctorContacts,
  fetchVendorList,
  fetcQMEDoctorHospitalList,
  validateDoctorAppointment,
} from "../../../../services/ScheduleAppointmentApi";
import { validateScheduleAppointment } from "../actions/ScheduleAppointmentValidation";
import Snackbar from "../../../../common/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/Store";
import EmployerDetailsCard from "../../Case_Subject/components/EmployeeDetailsCard";
import {
  GetMedicalAssistant,
  searchManualZipCode,
} from "../../../../services/StakeholderApi";
import TagComponent from "../../../../common/TagComponent";
import { formatDateTime } from "../../../../utils/dateUtils";
import moment from "moment";
import Loader from "../../../../common/Loader";
import AccordionComponent from "../../../../common/Accordion";
import EndTimePicker from "../../../../common/EndTimePicker";
import { setClientId } from "../../../../redux/slice/CaseHeaderSlice";
import SearchableAddressDropdown from "../../../../common/SearchableZipDropdown";
import { getPlaceByAddress } from "../../../../utils/getPlaceByAddress";
import { isValidCoordinate } from "../../../../utils/validators";
import { normalizeCountry, normalizeState } from "../../../../utils/normalizer";
import { addMedicareLocation } from "../../../../services/SystemLocationAPI";
import SearchAutosuggest from "../../../../common/SearchAutosuggestLocations";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import SearchHospitalAutosuggest, { LocationSuggestion } from "../../../../common/SearchHospitalAutosuggest";
import TextWithTooltip from "../../../../common/TextWithTooltip";
import { searchCaseSubjectByTextWithQMEDoctorWiseList } from "../../../../services/Case_SubjectAPI";

interface ScheduleAppointmentProps {
  onCancel?: (action: string) => void;
  selectedRowData?: any;
  setSelectedRowData?: any;
  slotData?: any;
  isScheduleAppointmentView?: boolean;
}

interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  medicareId?: string;
  providerName?: string;
  providerAddress?: string;
  countryName?: string;
}

interface OptionFprInterpreter {
  interpreterName?: string;
  interpreterPhoneNumber?: string;
  interpreterCertificateNumber?: string;
}

interface HospitalClinicSearchResult {
  areaName: string;
  districtName: string;
  localeName: string;
  physicalCity: string;
  physicalState: string;
  physicalZip: string;
  country: string;
}

const formattedDateTime = (date: string | Date): string | null => {
  if (!date) {
    console.error("Invalid input: date is required.");
    return null;
  }

  const formattedDate = moment(date).format("YYYY-MM-DD");
  return `${formattedDate}T00:00:00`;
};

const extractSpecialization = (name: string): string | null => {
  const parts = name?.split("(");
  if (parts?.length > 1) {
    return parts[1].replace(")", "")?.trim();
  }
  return null;
};

const QMEScheduleOnCalenderView: React.FC<ScheduleAppointmentProps> = ({
  onCancel = () => {},
  selectedRowData = {},
  setSelectedRowData = () => {},
  slotData = {},
  isScheduleAppointmentView = false,
}) => {
  const loggedInUserid: any = useSelector(
    (state: RootState) => state.auth.userid,
  );
  const params = {
    appointmentType: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Type,
      triggerById: loggedInUserid,
    },
    appointmentCategory: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Category,
      triggerById: loggedInUserid,
    },
    appointmentStatus: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Status,
      triggerById: loggedInUserid,
    },
    conductMedicalExam: {
      groupName: PICKLIST_GROUP_NAME.Conduct_Medical_Exam,
      triggerById: loggedInUserid,
    },
    interpreterLanguage: {
      groupName: PICKLIST_GROUP_NAME.Interpreter_Language,
      triggerById: loggedInUserid,
    },
    location: {
      groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
      triggerById: loggedInUserid,
    },
  };

  const currentTime = moment(new Date(slotData?.startDate)).format("HH:mm");
  // const currentendTimeNew = moment(new Date(slotData?.startDate))
  //   .add(1, "minutes")
  //   .format("HH:mm");
  const currentendTimeNew =
    slotData?.viewMode === "month"
      ? moment(new Date(slotData?.startDate)).add(30, "minutes").format("HH:mm")
      : moment(new Date(slotData?.endDate)).format("HH:mm");
  const [loading, setLoading] = useState(false);
  const { caseInfoId, caseid, claimnumber, patientDetails } = useSelector(
    (state: RootState) => state.caseHeader,
  );
  const { caseSubjectId } = useSelector(
    (state: RootState) => state.caseSubject,
  );
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [dateOfAppointment, setDateOfAppointment] = useState<Date | null>(
    new Date(slotData?.startDate),
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [startTime, setStartTime] = useState<any>(currentTime);
  const [endTime, setEndTime] = useState<any>(currentendTimeNew);
  const [duration, setDuration] = useState<string | null | number>(null);
  const [appointmentType, setAppointmentType] = useState<
    string | null | number
  >(null);
  const [appointmentTypeOptions, setAppointmentTypeOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [QMEDoctor, setQMEDoctor] = useState<string | null | number>(null);
  const [specialization, setSpecialization] = useState<string | null | number>(
    "",
  );
  const [medicalAssistance, setMedicalAssistance] = useState<
    string | null | number
  >(null);
  const [medicalAssistanceOptions, setMedicalAssistanceOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [appointmentNumber, setAppointmentNumber] = useState<
    string | null | number
  >("");
  const [appointmentStatus, setAppointmentStatus] = useState<
    string | null | number
  >(null);
  const [appointmentStatusOptions, setAppointmentStatusOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [appointmentCategory, setAppointmentCategory] = useState<
    string | null | number
  >(null);
  const [appointmentCategoryOptions, setAppointmentCategoryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [medicalExamOptions, setMedicalExamOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [ismedicalExam, setIsMedicalExam] = useState<string | null>(null);
  const [reasonForVisit, setReasonForVisit] = useState<string | null | number>(
    "",
  );
  const [isTransportation, setIsTransportation] = useState<boolean>(false);
  const [specifyNeeds, setSpecifyNeeds] = useState<string>("");
  const [isInterpreterReq, setIsInterpreterReq] = useState<boolean>(false);
  const [languageNeed, setLanguageNeed] = useState<string | null | number>(
    null,
  );
  const [languageNeedLabel, setLanguageNeedLabel] = useState<string>("");
  const [languageNeedOptions, setLanguageNeedOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [vendor, setVendor] = useState<string | null | number>(null);
  const [vendorOptions, setVendorOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [clinicDetails, setClinicDetails] = useState<any[]>([]);
  const [clinicId, setClinicId] = useState<string | null | number>(null);
  const [medicalExamValue, setMedicalExamValue] = useState<any>(null);
  const [result, setResult] = useState<any>({});
  const [clientResult, setClientResult] = useState({
    employerName: "",
    employerAddress: "",
    employerCity: "",
    employerState: "",
    employerZipcode: "",
    employerCountry: "",
    employerContact: "",
    empcontactemailaddress: "",
    empcontactphonenumber: "",
    empcontactfaxnumber: "",
  });
  const [phoneNumber, setPhoneNumber] = useState<string[]>([]);
  const [emailAddress, setEmailAddress] = useState<string[]>([]);
  const [faxNumber, setFaxNumber] = useState<string[]>([]);
  const [showAddClinic, setShowAddClinic] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, state: false, country: false, zip: false });
  const [selectedOptionNew, setSelectedOptionNew] = useState<Option | null>(
    null,
  );
  const [addressDetails, setAddressDetails] = useState({
    city: "",
    state: "",
    country: "",
    zip: "",
    medicareId: "",
    providerName: "",
    providerAddress: "",
  });
  const dropdownRef = useRef<HTMLDivElement>(null);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [showModalNew, setShowModalNew] = useState(false);
  const [isValidateDate, setIsValidateDate] = useState(false);
  const [isStartTimeChange, setisStartTimeChange] = useState(false);
  const [searchQueryForInterpreter, setSearchQueryForInterpreter] =
    useState<string>("");
  const [filteredResultsForInterpreter, setFilteredResultsForInterpreter] =
    useState<OptionFprInterpreter[]>([]);
  const [selectedOptionForInterpreter, setSelectedOptionForInterpreter] =
    useState<any>(null);
  const [showAddInterpreter, setShowAddInterpreter] = useState(false);
  const [interpreterDetailsName, setInterpreterDetailsName] =
    useState<string>("");
  const [interpreterDetailsPhoneNo, setInterpreterDetailsPhoneNo] = useState<
    string[]
  >([]);
  const [interpreterDetailsCertiNo, setInterpreterDetailsCertiNo] =
    useState<string>("");
  const [injuryOptions, setInjuryOptions] = useState<
    {
      value: string;
      label: string;
      claimNo: string;
      dateOfIncident: string;
      insuranceCarrier: string;
      injuryType: string;
    }[]
  >([]);
  const [injury, setInjury] = useState<string[]>([]);
  const [injuryDetails, setInjuryDetails] = useState({
    claimNo: "",
    dateOfIncident: "",
    insuranceCarrier: "",
  });
  const [isshowInterpreter, setIsShowInterpreter] = useState<boolean>(false);
  const [QMEDoctorReset, setQMEDoctorReset] = useState<string | null | number>(
    null,
  );
  const [injuryReset, setInjuryReset] = useState<string[]>([]);
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [manualLocation, setManualLocation] = useState("");
  const [manualAddress, setManualAddress] = useState("");
  const [manualCity, setManualCity] = useState("");
  const [manualState, setManualState] = useState("");
  const [manualCountry, setManualCountry] = useState("");
  const [manualZip, setManualZip] = useState("");
  const [cityOptions, setCityOptions] = useState<string[]>([]);
  const [stateOptions, setStateOptions] = useState<string[]>([]);
  const [countryOptions, setCountryOptions] = useState<string[]>([]);
  const [zipOptions, setZipOptions] = useState<string[]>([]);
  const [openUpward, setOpenUpward] = useState(false);
  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [isManualLocation, setIsManualLocation] = useState(false);
  const [pendingGoogleLocation, setPendingGoogleLocation] = useState<any>(null);
  const [searchQuery1, setSearchQuery1] = useState("");
  const [filteredResults1, setFilteredResults1] = useState<any[]>([]);
  const [selectedOption1, setSelectedOption1] = useState<any>(null);
  const [isAddNewPatient, setIsAddNewPatient] = useState(false);
  const [patientDetailsList, setPatientDetailsList] = useState<any>({});
  const viewScheduleAppointment = "Appointment";

  const safeApiCall = async (
    apiCall: Promise<any>,
    onSuccess: (data: any) => void,
  ) => {
    try {
      const res = await apiCall;
      onSuccess(res);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      if (slotData?.doctorId) {
        setQMEDoctor(slotData?.doctorId);
        setQMEDoctorReset(slotData?.doctorId);
        fetchHospitalList(slotData?.doctorId);
      }
      safeApiCall(fetchPickListByGroupName(params.appointmentType), (res) => {
        setAppointmentTypeOptions(res || []);
      });

      safeApiCall(
        fetchPickListByGroupName(params.appointmentCategory),
        (res) => {
          setAppointmentCategoryOptions(res || []);
        },
      );

      safeApiCall(fetchPickListByGroupName(params.appointmentStatus), (res) => {
        setAppointmentStatusOptions(res || []);
      });

      safeApiCall(
        fetchPickListByGroupName(params.conductMedicalExam),
        (res) => {
          setMedicalExamOptions(res || []);
        },
      );

      safeApiCall(
        fetchPickListByGroupName(params.interpreterLanguage),
        (res) => {
          setLanguageNeedOptions(res || []);
        },
      );

      safeApiCall(fetchVendorList(), (res) => {
        setVendorOptions(res || []);
      });

      if (isScheduleAppointmentView && caseInfoId) {
        safeApiCall(fetchInjuryListDetails(caseInfoId), (res) => {
          setInjuryOptions(res || []);

          const selectedPrimary = res?.find(
            (item: any) => item.isPrimaryInjury === 1,
          );

          if (!selectedRowData?.subjectQmeScheduleId) {
            setInjury([selectedPrimary?.value || res?.[0]?.value]);
            setInjuryReset([selectedPrimary?.value || res?.[0]?.value]);
          }
        });

        safeApiCall(GetMedicalAssistant(caseInfoId), (res) => {
          const medicareAssistanceData = res?.result?.map((item: any) => ({
            value: item.userId,
            label: item.medicalAssistantNames,
          }));
          setMedicalAssistanceOptions(medicareAssistanceData || []);
        });
      }
      safeApiCall(fetchPickListByGroupName(params.location), (res) => {
        setInstructionOption(res || []);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (patientDetailsList?.caseInfoId) {
      safeApiCall(
        fetchInjuryListDetails(patientDetailsList?.caseInfoId),
        (res) => {
          setInjuryOptions(res || []);

          const selectedPrimary = res?.find(
            (item: any) => item.isPrimaryInjury === 1,
          );

          if (!selectedRowData?.subjectQmeScheduleId) {
            setInjury([selectedPrimary?.value || res?.[0]?.value]);
            setInjuryReset([selectedPrimary?.value || res?.[0]?.value]);
          }
        },
      );

      safeApiCall(
        GetMedicalAssistant(patientDetailsList?.caseInfoId),
        (res) => {
          const medicareAssistanceData = res?.result?.map((item: any) => ({
            value: item.userId,
            label: item.medicalAssistantNames,
          }));
          setMedicalAssistanceOptions(medicareAssistanceData || []);
        },
      );
    }
  }, [patientDetailsList]);

  useEffect(() => {
    if (ismedicalExam === null) {
      const inPersonExam = medicalExamOptions?.find(
        (item: { label: string }) => item.label === "In-Person",
      );

      if (inPersonExam) {
        setIsMedicalExam(inPersonExam.value);
        setMedicalExamValue(inPersonExam.value);
      }
    }
  }, [medicalExamOptions]);

  useEffect(() => {
    if (result?.contactMedicareListId && clinicDetails?.length) {
      const selectedClinic = clinicDetails?.find(
        (clinic) => clinic.value === result?.contactMedicareListId,
      );

      if (selectedClinic) {
        setClientResult({
          employerName: selectedClinic.providerName || "",
          employerAddress: selectedClinic.providerAddress || "",
          employerCity: selectedClinic.physicalCity || "",
          employerState: selectedClinic.physicalState || "",
          employerZipcode: selectedClinic.physicalZip || "",
          employerCountry: selectedClinic.countryName || "",
          employerContact: "",
          empcontactemailaddress: selectedClinic.emailAddress || "",
          empcontactphonenumber: selectedClinic.phoneNumber || "",
          empcontactfaxnumber: selectedClinic.faxNumber || "",
        });
      }
    }
  }, [clinicDetails, result]);

  const validationCheck = async (Id: any) => {
    try {
      const payload = {
        qmeDoctorContactId: Id,
        dateOfAppointment: dateOfAppointment
          ? formattedDateTime(dateOfAppointment)
          : null,
        startTime:
          startTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, startTime)
            : null,
        endTime:
          endTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, endTime)
            : null,
        subjectQMEScheduleId: selectedRowData?.subjectQmeScheduleId
          ? selectedRowData?.subjectQmeScheduleId
          : 0,
      };
      const data = await validateDoctorAppointment(payload);
      if (data?.result?.isConflict == 1) {
        setSnackbarMessage(data?.result?.responseMessage);
        setError("error");
        setSnackbarOpen(true);
        setIsValidateDate(true);
        const isSameTime =
          startTime === currentTime && endTime === currentendTimeNew;
        // if (isSameTime) {
        //   setStartTime("");
        //   setEndTime("");
        //   setDuration(null);
        // } else {
        //   setStartTime(currentTime);
        //   setEndTime(currentendTimeNew);
        // }
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error fetching data:", error);
      return false;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!event.target.closest(".form-floating")) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (startTime && endTime) {
      const start = new Date(`1970-01-01T${startTime}:00`);
      const end = new Date(`1970-01-01T${endTime}:00`);
      const diffInMilliseconds = end.getTime() - start.getTime();
      const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

      if (diffInMinutes >= 0) {
        const hours = Math.floor(diffInMinutes / 60);
        const minutes = diffInMinutes % 60;
        let durationString = "";
        if (hours > 0) durationString += `${hours}h`;
        if (minutes > 0) durationString += ` ${minutes}m`;
        setDuration(durationString.trim());
        setIsValidateDate(false);
      } else {
        setDuration("");
      }

      // if (QMEDoctor && isStartTimeChange) {
      //   validationCheck(QMEDoctor);
      // }
    } else {
      setDuration("");
      setIsValidateDate(false);
      setisStartTimeChange(false);
    }
  }, [startTime, endTime]);

  const handleStartTimeChange = (time: string) => {
    setStartTime(time);
    setisStartTimeChange(true);

    // Validate if the time is in HH:MM format
    const isValidTime = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time);
    if (isValidTime) {
      const [hours, minutes] = time.split(":").map(Number);

      // Calculate total minutes from 00:00
      const totalMinutes = hours * 60 + minutes;
      const endTotalMinutes = totalMinutes + 1;

      // If end time exceeds 23:59 (1439 minutes), cap it
      const finalMinutes = Math.min(endTotalMinutes, 1439);
      const endHours = Math.floor(finalMinutes / 60);
      const endMinutes = finalMinutes % 60;

      const newEndTime = `${String(endHours).padStart(2, "0")}:${String(
        endMinutes,
      ).padStart(2, "0")}`;
      setEndTime(newEndTime);
    } else {
      setEndTime("");
    }
  };

  const fetchHospitalList = async (Id: any) => {
    try {
      const data = await fetcQMEDoctorHospitalList(Id);
      setClinicDetails(data || []);
      if (slotData?.medicareId) {
        const matchedHospital = data?.find(
          (h: any) => Number(h.medicareId) === Number(slotData?.medicareId),
        );

        if (matchedHospital) {
          setSelectedOptionNew(matchedHospital);
          setClinicId(matchedHospital.contactMedicareListId);
          setClientId(matchedHospital.contactMedicareListId);
          setClientResult({
            employerName: matchedHospital.providerName || "",
            employerAddress: matchedHospital.providerAddress || "",
            employerCity: matchedHospital.physicalCity || "",
            employerState: matchedHospital.physicalState || "",
            employerZipcode: matchedHospital.physicalZip || "",
            employerCountry: matchedHospital.countryName || "",
            employerContact: "",
            empcontactemailaddress: matchedHospital.emailAddress || "",
            empcontactphonenumber: matchedHospital.phoneNumber || "",
            empcontactfaxnumber: matchedHospital.faxNumber || "",
          });
        } else {
          setSelectedOptionNew(null);
          setClientId(null);
          setClinicId(null);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const validateData = () => {
    const validationErrors = validateScheduleAppointment(
      dateOfAppointment,
      startTime,
      endTime,
      appointmentType,
      QMEDoctor,
      appointmentCategory,
      ismedicalExam,
      specifyNeeds,
      isTransportation,
      isInterpreterReq,
      languageNeed,
      vendor,
      clinicId,
      showAddClinic,
      addressDetails,
      emailAddress,
      phoneNumber,
      faxNumber,
      interpreterDetailsName,
      interpreterDetailsPhoneNo,
      interpreterDetailsCertiNo,
      showAddInterpreter,
      injury,
      isManualEntry,
      manualAddress,
      manualLocation,
      manualCity,
      manualCountry,
      manualState,
      manualZip,
      patientDetailsList,
      isScheduleAppointmentView,
      viewScheduleAppointment,
    );

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Element;
      if (target.closest("#datepicker-input, .date_ic, .react-datepicker")) {
        return;
      }
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setFilteredResultsForInterpreter([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSuggestionSelect = (suggestion: LocationSuggestion) => {
    const newStateCode = suggestion.physicalStateCode || normalizeState(suggestion.physicalState || "");
    const newCountryCode = normalizeCountry(suggestion.country || "");
    if (suggestion.source === "google") {
      setPendingGoogleLocation({
        source: "google",
        providerName: suggestion.providerName,
        providerAddress: suggestion.providerAddress,
        physicalCity: suggestion.physicalCity,
        physicalState: newStateCode,
        physicalZip: suggestion.physicalZip,
        countryName: newCountryCode,
        county: suggestion.county,
        areaName: suggestion.areaName || "",
        latitude: isValidCoordinate(suggestion.latitude) ? String(suggestion.latitude) : "",
        longitude: isValidCoordinate(suggestion.longitude) ? String(suggestion.longitude) : "",
      });
    } else {
      setPendingGoogleLocation(null);
    }
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      state: !!newStateCode,
      country: !!newCountryCode,
      zip: !!suggestion.physicalZip,
    });
    setAddressDetails({
      city: suggestion.physicalCity || "",
      state: newStateCode,
      country: newCountryCode || "USA",
      zip: suggestion.physicalZip || "",
      medicareId: suggestion.medicareId || "",
      providerName: suggestion.providerName || "",
      providerAddress: suggestion.providerAddress || "",
    });
  };

  const handleSearchChange1 = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    const qmeDoctorId = slotData?.doctorId;
    setSearchQuery1(value);
    setFilteredResults1([]);
    if (value.length >= 3) {
      try {
        const results = await searchCaseSubjectByTextWithQMEDoctorWiseList(
          value?.trim(),
          qmeDoctorId,
        );
        if (Array.isArray(results)) {
          setFilteredResults1(results);
        }
      } catch (error) {
        console.error("Search failed", error);
        setFilteredResults1([]);
      }
    } else {
      setFilteredResults1([]);
    }
  };

  const handleSelect1 = (option: any) => {
    setSelectedOption1(option);
    setSearchQuery1(
      `${option.salutationName ?? ""} ${option.firstName ?? ""} ${option.middleName ?? ""} ${option.lastName ?? ""} (${option.patientAccountNo ?? ""}) | ${option.caseType_ExamType ?? ""} | ${option.caseId ?? ""} | ${option.claimNumber ?? ""}`,
    );
    setPatientDetailsList(option);
    setIsAddNewPatient(false);
    setFilteredResults1([]);
  };

  const handleSearchChangeForInterpreter = async (
    e: ChangeEvent<HTMLInputElement>,
  ) => {
    const query = e.target.value;
    if (query.startsWith(" ")) {
      return;
    }
    setSearchQueryForInterpreter(query);
    const trimmedQuery = query.trim();
    if (trimmedQuery.length < 3) {
      setFilteredResultsForInterpreter([]);
      return;
    }

    try {
      const response: any = await fetchInterpreterListDetails(
        trimmedQuery,
        languageNeedLabel,
      );

      if (Array.isArray(response.result)) {
        setFilteredResultsForInterpreter(response.result);
      } else {
        setFilteredResultsForInterpreter([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSelectDropdown = (option: any) => {
    setSelectedOptionNew(option);
    setClinicId(option.contactMedicareListId);
    setDropdownOpen(false);
    setClientResult({
      employerName: option.providerName || "",
      employerAddress: option.providerAddress || "",
      employerCity: option.physicalCity || "",
      employerState: option.physicalState || "",
      employerZipcode: option.physicalZip || "",
      employerCountry: option.countryName || "",
      employerContact: "",
      empcontactemailaddress: option.emailAddress || "",
      empcontactphonenumber: option.phoneNumber || "",
      empcontactfaxnumber: option.faxNumber || "",
    });
  };

  const handleSelectInterpreterDropdown = (option: any) => {
    setIsShowInterpreter(true);
    setSelectedOptionForInterpreter(option);
    setSearchQueryForInterpreter(option.interpreterName || "");
    setInterpreterDetailsName(option.interpreterName || "");
    setInterpreterDetailsPhoneNo(
      option.interpreterPhoneNumber
        ? option.interpreterPhoneNumber
            .split(",")
            .map((num: string) => num.trim())
        : [],
    );
    setInterpreterDetailsCertiNo(option.interpreterCertificateNumber || "");
    setFilteredResultsForInterpreter([]);
  };

  const handleSubmit = async () => {
    if (validateData()) {
      setLoading(true);
      const isConflict = await validationCheck(QMEDoctor);
      if (isConflict) {
        setLoading(false);
        return;
      }

      const appointmentStatusID = appointmentStatusOptions?.find(
        (item) => item.label === QME_APPOINTMENT_STATUS.SCHEDULED,
      )?.value;
      const medicalExamID = medicalExamOptions?.find(
        (item) => item.label === "In-Person",
      )?.value;

      let fixedLoc: { latitude?: number | null; longitude?: number | null } =
        {};
      if (manualLocation) {
        const addressInDetails = `${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
        const locationInDetails = `${manualLocation}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
        const locationFullDetails = `${manualLocation}, ${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;

        const placeResult = await getPlaceByAddress({
          name: locationInDetails,
          address: addressInDetails,
          fullAddress: locationFullDetails,
        });
        if (placeResult) {
          fixedLoc = {
            latitude: placeResult.latitude,
            longitude: placeResult.longitude,
          };
        }
      }

      let splInstructionsPayload: any[] = [];
      splInstructionsPayload = instructionOption.map((opt: any) => ({
        splInstructionID: opt.value,
        splInstructionData: "",
      }));

      const useGoogleFallback =
        showAddClinic &&
        !isManualEntry &&
        pendingGoogleLocation?.source === "google";

      const basePayload = {
        caseSubjectId: isScheduleAppointmentView
          ? caseSubjectId
          : patientDetailsList?.caseSubjectId,
        subjectQMEScheduleId: 0,
        dateOfAppointment: dateOfAppointment
          ? formatDateTime(dateOfAppointment)
          : null,
        startTime:
          startTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, startTime)
            : null,
        endTime:
          endTime && dateOfAppointment
            ? formatDateTime(dateOfAppointment, endTime)
            : null,
        appointmentTypeId: appointmentType || null,
        appointmentCategoryId: appointmentCategory || null,
        qmeDoctorContactId: Number(QMEDoctor) || null,
        appointmentStatusId: appointmentStatusID,
        appointmentStatusLable: QME_APPOINTMENT_STATUS.SCHEDULED,
        appointmentConfirmationNo: appointmentNumber || "",
        reasonForVisit: reasonForVisit || "",
        medicalExamTypeId:
          ismedicalExam != null ? ismedicalExam : medicalExamID,
        anyAdditionalNeeds: specifyNeeds || "",
        isInterpreterRequired: isInterpreterReq ? 1 : 0,
        interpreterLanguageId: languageNeed || null,
        interpreterVendorId: vendor || null,
        interpreterName: interpreterDetailsName,
        interpreterPhoneNumber:
          interpreterDetailsPhoneNo?.length > 0
            ? interpreterDetailsPhoneNo.join(",")
            : "",
        interpreterCertificateNumber: interpreterDetailsCertiNo,
        caseSubjectInjuryId: injury.join(",") || "",
        contactMedicareListId: clinicId ? clinicId : null,
        medicareId: isManualEntry ? null : addressDetails?.medicareId || null,
        providerName: manualLocation
          ? manualLocation
          : clientResult?.employerName && !showAddClinic
            ? clientResult.employerName
            : addressDetails?.providerName,

        providerAddress: manualAddress
          ? manualAddress
          : clientResult?.employerAddress && !showAddClinic
            ? clientResult.employerAddress
            : addressDetails?.providerAddress,
        physicalCity: manualCity
          ? manualCity
          : clientResult?.employerCity && !showAddClinic
            ? clientResult.employerCity
            : addressDetails?.city,
        physicalState: manualState
          ? manualState
          : clientResult?.employerState && !showAddClinic
            ? clientResult.employerState
            : addressDetails?.state,
        physicalZip: manualZip
          ? manualZip
          : clientResult?.employerZipcode && !showAddClinic
            ? clientResult.employerZipcode
            : addressDetails?.zip,
        emailAddress: emailAddress?.length > 0 ? emailAddress.join(",") : "",
        phoneNumber: phoneNumber?.length > 0 ? phoneNumber.join(",") : "",
        faxNumber: faxNumber?.length > 0 ? faxNumber.join(",") : "",
        medicalAssistantId: medicalAssistance || null,
      };

      const payload = {
        ...basePayload,
        ...(useGoogleFallback && {
          latitude: String(pendingGoogleLocation.latitude),
          longitude: String(pendingGoogleLocation.longitude),
          splInstructions: splInstructionsPayload,
        }),
        ...(!useGoogleFallback &&
          manualLocation &&
          isValidCoordinate(fixedLoc?.latitude) &&
          isValidCoordinate(fixedLoc?.longitude) && {
            latitude: String(fixedLoc.latitude),
            longitude: String(fixedLoc.longitude),
          }),
        ...(!useGoogleFallback && manualLocation && {
          splInstructions: splInstructionsPayload,
        }),
      };

      try {
        const response = await addQMEScheduleDetails(payload);
        if (response?.isSuccess && response?.statusCode == 200) {
          setSnackbarMessage("Appointment Scheduled Successfully.");
          setError("success");
          setSnackbarOpen(true);
          setShowAddInterpreter(false);
          setShowAddClinic(false);
          setSearchQuery("");
          setSearchQueryForInterpreter("");
          setInterpreterDetailsPhoneNo([]);
          setInterpreterDetailsCertiNo("");
          setSearchQueryForInterpreter("");
          setIsShowInterpreter(false);
          setClinicId(null);
          setSelectedOptionNew(null);
          setSuggestionSelected(false);
          setSuggestionFilled({ city: false, state: false, country: false, zip: false });
          setAddressDetails({
            city: "",
            state: "",
            country: "",
            zip: "",
            medicareId: "",
            providerName: "",
            providerAddress: "",
          });
          setPhoneNumber([]);
          setEmailAddress([]);
          setFaxNumber([]);
          setSelectedRowData(null);
          setInjury([]);
          setInjuryDetails({
            claimNo: "",
            dateOfIncident: "",
            insuranceCarrier: "",
          });
          setTimeout(() => {
            onCancel("Submit");
          }, 1000);
        } else {
          setSnackbarMessage(
            response?.message || "Failed to process appointment.",
          );
          setError("error");
          setSnackbarOpen(true);
          setSearchQuery("");
          setClinicId(null);
          setSelectedOptionNew(null);
          setSuggestionSelected(false);
          setSuggestionFilled({ city: false, state: false, country: false, zip: false });
          setAddressDetails({
            city: "",
            state: "",
            country: "",
            zip: "",
            medicareId: "",
            providerName: "",
            providerAddress: "",
          });
          setPhoneNumber([]);
          setEmailAddress([]);
          setFaxNumber([]);
        }
      } catch (error) {
        console.error("Error processing appointment:", error);
        setSnackbarMessage(
          "An error occurred while processing the appointment.",
        );
        setSnackbarOpen(true);
        setError("error");
      } finally {
        setLoading(false);
        setisStartTimeChange(false);
      }
    }
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = async () => {
    if (selectedRowData?.subjectQmeScheduleId) {
      await fetchData();
    } else {
      resetData();
    }
    setShowModalNew(false);
  };

  const resetData = () => {
    setDateOfAppointment(new Date());
    setStartTime(currentTime);
    setEndTime(currentendTimeNew);
    setisStartTimeChange(false);
    setDuration(null);
    setAppointmentType(null);
    setSpecialization("");
    setMedicalAssistance(null);
    setAppointmentNumber("");
    setAppointmentStatus(null);
    setAppointmentCategory(null);
    setIsMedicalExam(medicalExamValue);
    setReasonForVisit(null);
    setIsTransportation(false);
    setSpecifyNeeds("");
    setIsInterpreterReq(false);
    setLanguageNeed(null);
    setIsShowInterpreter(false);
    setShowAddInterpreter(false);
    setSelectedOptionForInterpreter(null);
    setInterpreterDetailsName("");
    setInterpreterDetailsPhoneNo([]);
    setInterpreterDetailsCertiNo("");
    setSearchQueryForInterpreter("");
    setVendor(null);
    setClinicId(null);
    setResult({});
    setClientResult({
      employerName: "",
      employerAddress: "",
      employerCity: "",
      employerState: "",
      employerZipcode: "",
      employerCountry: "",
      employerContact: "",
      empcontactemailaddress: "",
      empcontactphonenumber: "",
      empcontactfaxnumber: "",
    });
    setPhoneNumber([]);
    setEmailAddress([]);
    setFaxNumber([]);
    setShowAddInterpreter(false);
    setShowAddClinic(false);
    setSearchQuery("");
    setSearchQueryForInterpreter("");
    setSelectedOptionNew(null);
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
      medicareId: "",
      providerName: "",
      providerAddress: "",
    });
    setPendingGoogleLocation(null);
    setQMEDoctor(QMEDoctorReset);
    setInjury(injuryReset);
  };

  const [scheduleAppointmentKey, setscheduleAppointmentKey] = useState<
    string | null
  >("0");
  const [medicalExamKey, setmedicalExamKey] = useState<string | null>("0");

  const medicalExamAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={medicalExamKey}
      onSelect={(key) => setmedicalExamKey(key as string)}
    />
  );

  const [addcomDetailKey, setaddcomDetailKey] = useState<string | null>("0");
  const [interpreterDetailKey, setInterpreterDetailKey] = useState<
    string | null
  >("0");
  const [injuryDetailKey, setInjuryDetailKey] = useState<string | null>("0");

  const addcomDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addcomDetailKey}
      onSelect={(key) => setaddcomDetailKey(key as string)}
    />
  );

  const [clinicDetailKey, setclinicDetailKey] = useState<string | null>("0");
  const clinicDetailFormAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={clinicDetailKey}
      onSelect={(key) => setclinicDetailKey(key as string)}
    />
  );

  const interpreterDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={interpreterDetailKey}
      onSelect={(key) => setInterpreterDetailKey(key as string)}
    />
  );

  const injuryDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={injuryDetailKey}
      onSelect={(key) => setInjuryDetailKey(key as string)}
    />
  );

  const handleEnterNewLocation = () => {
    setIsManualEntry(true);
    setIsManualLocation(false);
  };

  const [searchResults, setSearchResults] = useState<
    HospitalClinicSearchResult[]
  >([]);

  const handleSearch = async (query: string) => {
    try {
      const response = await searchManualZipCode({
        SearchString: query,
        pageNo: 0,
        pageSize: 0,
        sortColumn: "",
        sortOrder: "",
      });

      const results: HospitalClinicSearchResult[] = response?.result || [];

      if (results.length > 0) {
        setSearchResults(results);

        const cities = [
          ...new Set(results.map((r) => r.physicalCity).filter(Boolean)),
        ];
        const zips = [
          ...new Set(results.map((r) => r.physicalZip).filter(Boolean)),
        ];
        const states = [
          ...new Set(results.map((r) => r.physicalState).filter(Boolean)),
        ];
        const countries = [
          ...new Set(results.map((r) => r.country).filter(Boolean)),
        ];

        setCityOptions(cities);
        setZipOptions(zips);
        setStateOptions(states);
        setCountryOptions(countries);
        if (!cities.includes(manualCity)) setManualCity("");
        if (!zips.includes(manualZip)) setManualZip("");
        if (!states.includes(manualState)) setManualState("");
        if (!countries.includes(manualCountry)) setManualCountry("");
      }
    } catch (error) {
      console.error("Error searching clinic data:", error);
    } finally {
      // Optional: setLoading(false);
    }
  };

  // Update dropdown options from unfiltered searchResults
  useEffect(() => {
    const cities = [
      ...new Set(searchResults.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const states = [
      ...new Set(searchResults.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(searchResults.map((r) => r.country).filter(Boolean)),
    ];
    const zips = [
      ...new Set(searchResults.map((r) => r.physicalZip).filter(Boolean)),
    ];

    setCityOptions(cities);
    setStateOptions(states);
    setCountryOptions(countries);
    setZipOptions(zips);
  }, [searchResults]);

  useEffect(() => {
    if (!manualCity && !manualZip) return;

    let filtered = [...searchResults];

    if (manualCity?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalCity?.toLowerCase() === manualCity.trim().toLowerCase(),
      );
    }

    if (manualZip?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalZip?.toLowerCase() === manualZip.trim().toLowerCase(),
      );
    }

    const cities = [
      ...new Set(filtered.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const zips = [
      ...new Set(filtered.map((r) => r.physicalZip).filter(Boolean)),
    ];
    const states = [
      ...new Set(filtered.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(filtered.map((r) => r.country).filter(Boolean)),
    ];

    setCityOptions(cities);
    setZipOptions(zips);
    setStateOptions(states);
    setCountryOptions(countries);

    if (cities.length === 1 && !manualCity) setManualCity(cities[0]);
    if (zips.length === 1 && !manualZip) setManualZip(zips[0]);
    if (states.length === 1 && !manualState) setManualState(states[0]);
    if (countries.length === 1 && !manualCountry)
      setManualCountry(countries[0]);
  }, [manualCity, manualZip, searchResults]);

  const handleInjuryChange = (selectedValues: any) => {
    setInjury(Array.isArray(selectedValues) ? selectedValues : []);
  };

  const handleAddressSuggestionSelect = async (suggestion: any) => {
    setIsManualLocation(false);
    setManualAddress(suggestion.providerAddress || "");
    setManualLocation(suggestion.providerName || "");

    const suggestedZip = suggestion.physicalZip || "";
    const newStateCode = normalizeState(suggestion.physicalState);
    const newCountryCode = normalizeCountry(suggestion.country) || "USA";

    if (suggestion.physicalCity) setManualCity(suggestion.physicalCity);
    if (suggestion.physicalState) setManualState(newStateCode);
    if (suggestion.country) setManualCountry(newCountryCode);

    if (suggestion.physicalCity) setCityOptions([suggestion.physicalCity]);
    if (newStateCode) setStateOptions([newStateCode]);
    if (newCountryCode) setCountryOptions([newCountryCode]);

    if (suggestedZip) {
      setManualZip(suggestedZip);
      setZipOptions([suggestedZip]);

      try {
        const response = await searchManualZipCode({
          SearchString: suggestedZip,
          pageNo: 0,
          pageSize: 10,
          sortColumn: "",
          sortOrder: "",
        });

        const results = response?.result || [];

        if (results.length > 0) {
          const typedResults = results as HospitalClinicSearchResult[];
          const cities = [
            ...new Set(typedResults.map((r) => r.physicalCity).filter(Boolean)),
          ] as string[];
          const zips = [
            ...new Set(typedResults.map((r) => r.physicalZip).filter(Boolean)),
          ] as string[];
          const states = [
            ...new Set(
              typedResults.map((r) => r.physicalState).filter(Boolean),
            ),
          ] as string[];
          const countries = [
            ...new Set(typedResults.map((r) => r.country).filter(Boolean)),
          ] as string[];

          setCityOptions(cities);
          setZipOptions(zips);
          setStateOptions(states);
          setCountryOptions(countries);
        }
      } catch (error) {
        console.error("Zip lookup failed, using suggestion values:", error);
      }
    }
  };

  const handleManualLocationAdd = () => {
    setIsManualLocation(true);
    setManualLocation("");
    setManualAddress("");
    setManualCity("");
    setManualState("");
    setManualZip("");
    setManualCountry("");
  };

  useEffect(() => {
    if (!dropdownOpen || !dropdownRef.current) return;

    const rect = dropdownRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;

    const DROPDOWN_HEIGHT = 260;

    if (spaceBelow < DROPDOWN_HEIGHT && spaceAbove > spaceBelow) {
      setOpenUpward(true);
    } else {
      setOpenUpward(false);
    }
  }, [dropdownOpen]);

  const selectedInjuryDetails = injury
    ?.map((value) => injuryOptions.find((opt) => opt.value === value))
    .filter(Boolean);
  const patientInfo = `${patientDetails} | ${caseid} | ${claimnumber}`;

  return (
    <>
      <Container fluid className="px-0">
        <Loader isLoading={loading} />
        <Snackbar
          message={snackbarMessage}
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        <Row className="mt-1">
          <Col sm={12}>
            <div
              style={{
                background: "#cce8f4",
                borderRadius: "4px",
                padding: "10px 14px",
              }}
            >
              <Row className="g-0">
                <Col
                  sm={slotData?.medicareId ? 4 : 6}
                  style={{
                    borderRight: "1px solid #a8d5ea",
                    paddingRight: "12px",
                  }}
                >
                  <div className="d-flex align-items-center mb-1">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-qme-doctor">Date</Tooltip>}
                    >
                      <span
                        className="material-icons material-symbols-outlined theme-color"
                        style={{ marginRight: "3px", fontSize: "21px" }}
                      >
                        calendar_month
                      </span>
                    </OverlayTrigger>
                    <span style={{ fontSize: "13px", fontWeight: "500" }}>
                      {dateOfAppointment
                        ? moment(dateOfAppointment).format("MM/DD/YYYY")
                        : ""}
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-1">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-qme-doctor">Time</Tooltip>}
                    >
                      <span
                        className="material-icons material-symbols-outlined theme-color"
                        style={{ marginRight: "3px", fontSize: "21px" }}
                      >
                        alarm
                      </span>
                    </OverlayTrigger>
                    <span style={{ fontSize: "13px", fontWeight: "500" }}>
                      {startTime && endTime
                        ? `${moment(startTime, "HH:mm").format("hh:mm A")} - ${moment(endTime, "HH:mm").format("hh:mm A")}`
                        : ""}
                    </span>
                    <span style={{ fontSize: "13px", fontWeight: "500" }}>
                      {" "}
                      &nbsp; [{duration ? duration : ""}]
                    </span>
                  </div>
                </Col>
                {slotData?.doctorName && (
                  <Col
                    sm={slotData?.medicareId ? 3 : 6}
                    style={{
                      ...(slotData?.medicareId
                        ? { borderRight: "1px solid #a8d5ea" }
                        : {}),
                      paddingLeft: "12px",
                      paddingRight: "12px",
                    }}
                  >
                    <div style={{ fontSize: "13px", fontWeight: "500" }}>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-qme-doctor">QME Doctor</Tooltip>
                        }
                      >
                        <span
                          className="material-icons material-symbols-outlined theme-color"
                          style={{
                            marginRight: "5px",
                            fontSize: "21px",
                            width: "23px",
                            float: "left",
                          }}
                        >
                          medical_services
                        </span>
                      </OverlayTrigger>
                      <span
                        style={{
                          verticalAlign: "top",
                          marginTop: "2px",
                          display: "inline-block",
                          width: "83%",
                          float: "left",
                        }}
                      >
                        {slotData?.doctorName || ""}
                      </span>
                    </div>
                  </Col>
                )}
                {slotData?.medicareId && (
                  <Col sm={5} style={{ paddingLeft: "12px" }}>
                    <div style={{ fontSize: "13px", fontWeight: "700" }}>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-qme-doctor">Location</Tooltip>
                        }
                      >
                        <span
                          className="material-icons material-symbols-outlined theme-color"
                          style={{
                            marginRight: "5px",
                            fontSize: "21px",
                            width: "23px",
                            float: "left",
                          }}
                        >
                          location_on
                        </span>
                      </OverlayTrigger>
                      <span
                        style={{
                          verticalAlign: "top",
                          marginTop: "2px",
                          display: "inline-block",
                          width: "91%",
                          float: "left",
                        }}
                      >
                        {clientResult?.employerName || manualLocation || ""}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#2980b9",
                        marginLeft: "30px",
                      }}
                    >
                      {clientResult?.employerAddress
                        ? `${clientResult.employerAddress}${clientResult.employerCity ? ` ${clientResult.employerCity},` : ""}${clientResult.employerState ? ` ${clientResult.employerState},` : ""}${clientResult.employerCountry ? ` ${clientResult.employerCountry}` : ""}${clientResult.employerZipcode ? ` ${clientResult.employerZipcode}` : ""}`
                        : manualAddress
                          ? `${manualAddress}${manualCity ? ` ${manualCity},` : ""}${manualState ? ` ${manualState},` : ""}${manualCountry ? ` ${manualCountry}` : ""}${manualZip ? ` ${manualZip}` : ""}`
                          : ""}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          {isScheduleAppointmentView ? (
            <Col sm={12}>
              <TextInput
                label="Patient Details"
                name="Patient_Details"
                value={patientInfo || ""}
                disabled
              />
            </Col>
          ) : (
            <Col md={12}>
              <div className="form-floating" ref={dropdownRef}>
                <input
                  type="text"
                  name="caseID"
                  className="form-control zipcodeDetailsOverlay"
                  placeholder="Case ID"
                  value={searchQuery1}
                  maxLength={100}
                  onChange={handleSearchChange1}
                  required
                  autoComplete="off"
                />
                <label>
                  Enter Patient Details <span style={{ color: "red" }}> *</span>
                </label>

                {!isAddNewPatient && filteredResults1.length > 0 && (
                  <div className="dropdown-results">
                    <ul
                      className="list-group custom-scroll-list"
                      style={{
                        maxHeight: "225px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <li className="list-group-item11 d-flex justify-content-between align-items-center fw-bold sticky-header">
                        <div className="col-5p"></div>
                        <div className="col-20p">Patient Account No</div>
                        <div className="col-20p">Patient Name</div>
                        <div className="col-20p">Case Type</div>
                        <div className="col-10p">DOB</div>
                        <div className="col-15p">Claim No</div>
                      </li>

                      {filteredResults1.map((option, index) => (
                        <li
                          key={index}
                          className="list-group-item11 d-flex justify-content-between align-items-evenly"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSelect1(option)}
                        >
                          <div className="col-5p">
                            <input
                              type="radio"
                              name="location"
                              checked={
                                selectedOption1?.subjectSSN ===
                                option.subjectSSN
                              }
                              onChange={() => handleSelect1(option)}
                            />
                          </div>
                          <div className="col-20p">
                            {option.patientAccountNo || ""}
                          </div>
                          <div className="col-20p">
                            {`${option.lastName}, ${option.firstName} ${
                              option.middleName ?? ""
                            }`}
                          </div>
                          <div className="col-20p">
                            {option.caseType_ExamType || ""}
                          </div>
                          <div className="col-10p">
                            {option.subjectDob
                              ? moment(option.subjectDob).format("MM/DD/YYYY")
                              : ""}
                          </div>
                          <div className="col-15p">{option.claimNumber}</div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </Col>
          )}
        </Row>
        {!slotData?.medicareId && (
          <Row className="mt-3">
            {medicalExamAccordion([
              {
                title: "Location Details",
                content: (
                  <>
                    <Row>
                      <Col md={9} className="acssociated-location">
                        <div
                          className="form-floating"
                          ref={dropdownRef}
                          onClick={() => setDropdownOpen(!dropdownOpen)}
                          style={{ position: "relative" }}
                        >
                          <input
                            type="text"
                            name="QME Doctor Associated Location"
                            className="form-control zipcodeDetailsOverlay"
                            placeholder="QME Doctor Associated Location"
                            maxLength={50}
                            value={
                              selectedOptionNew
                                ? selectedOptionNew.providerName
                                : ""
                            }
                            autoComplete="off"
                            readOnly
                            required
                            disabled={
                              showAddClinic ||
                              !QMEDoctor ||
                              clinicDetails?.length === 0 ||
                              (slotData?.medicareId &&
                                slotData?.viewMode !== "month")
                            }
                          />
                          <label>
                            QME Doctor Associated Location
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          {dropdownOpen && clinicDetails.length > 0 && (
                            <div
                              style={{
                                position: "absolute",
                                left: 0,
                                right: 0,
                                zIndex: 1050,
                                background: "#fff",
                                border: "1px solid #ccc",
                                top: openUpward ? "auto" : "100%",
                                bottom: openUpward ? "100%" : "auto",
                              }}
                            >
                              <ul
                                className="list-group"
                                style={{
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                }}
                              >
                                <li
                                  className="list-group-item d-flex justify-content-between align-items-center"
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  <div style={{ width: "10%" }}>Select</div>
                                  <div style={{ width: "30%" }}>Location</div>
                                  <div style={{ width: "20%" }}>City</div>
                                  <div style={{ width: "20%" }}>State</div>
                                  <div style={{ width: "12%" }}>Country</div>
                                  <div style={{ width: "11%" }}>Zipcode</div>
                                </li>

                                {clinicDetails.map((clinic) => (
                                  <li
                                    key={clinic.value}
                                    className={`list-group-item d-flex justify-content-between align-items-center ${
                                      selectedOptionNew?.providerName ===
                                      clinic.providerName
                                        ? "selected-row"
                                        : ""
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      handleSelectDropdown(clinic);
                                    }}
                                  >
                                    <div style={{ width: "10%" }}>
                                      <input
                                        type="radio"
                                        name="location"
                                        checked={
                                          selectedOptionNew?.providerName ===
                                          clinic.providerName
                                        }
                                        onChange={() =>
                                          handleSelectDropdown(clinic)
                                        }
                                      />
                                    </div>
                                    <div style={{ width: "30%" }}>
                                      {clinic.providerName}
                                    </div>
                                    <div style={{ width: "20%" }}>
                                      {clinic.physicalCity}
                                    </div>
                                    <div style={{ width: "20%" }}>
                                      {clinic.physicalState}
                                    </div>
                                    <div style={{ width: "11%" }}>
                                      {clinic.countryName}
                                    </div>
                                    <div style={{ width: "11%" }}>
                                      {clinic.physicalZip}
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col sm={3}>
                        <div className="d-flex align-items-center mb-3 mt-3">
                          <Form.Switch
                            id="show-previous-contacts"
                            label="Add Location"
                            checked={showAddClinic}
                            onChange={() => {
                              setShowAddClinic(!showAddClinic);
                              setClinicId(null);
                              setClientResult({
                                employerName: "",
                                employerAddress: "",
                                employerCity: "",
                                employerState: "",
                                employerZipcode: "",
                                employerCountry: "",
                                employerContact: "",
                                empcontactemailaddress: "",
                                empcontactphonenumber: "",
                                empcontactfaxnumber: "",
                              });
                              setAddressDetails({
                                city: "",
                                state: "",
                                country: "",
                                zip: "",
                                medicareId: "",
                                providerName: "",
                                providerAddress: "",
                              });
                              setSelectedOptionNew(null);
                              setSearchQuery("");
                              setIsManualEntry(false);
                              setManualLocation("");
                              setManualAddress("");
                              setManualCity("");
                              setManualState("");
                              setManualCountry("");
                              setManualZip("");
                              setCityOptions([]);
                              setStateOptions([]);
                              setCountryOptions([]);
                              setZipOptions([]);
                            }}
                            disabled={
                              slotData?.medicareId &&
                              slotData?.viewMode !== "month"
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                    {showAddClinic && (
                      <>
                        {!isManualEntry && (
                          <Row className="row mt-3">
                            <Col md={12}>
                              <SearchHospitalAutosuggest
                                value={searchQuery}
                                onChange={setSearchQuery}
                                onSuggestionSelect={handleSuggestionSelect}
                                onEnterNewLocation={handleEnterNewLocation}
                                showEnterNewLocation={true}
                                label="Location"
                                required
                                maxLength={50}
                              />
                            </Col>
                          </Row>
                        )}
                        {isManualEntry ? (
                          <Row className="row mb-3 mt-3">
                            <Col md={12}>
                              {!isManualLocation ? (
                                <SearchAutosuggest
                                  value={manualLocation}
                                  onChange={setManualLocation}
                                  onSuggestionSelect={
                                    handleAddressSuggestionSelect
                                  }
                                  onManualLocationAdd={handleManualLocationAdd}
                                  enableManualLocation={true}
                                  label="Location"
                                  required
                                  apiKey={
                                    process.env
                                      .REACT_APP_GOOGLE_PLACES_AUTOCOMPLETE_API_KEY
                                  }
                                  countryRestriction="us"
                                  sortingLocation="Location"
                                  maxLength={100}
                                />
                              ) : (
                                <TextInput
                                  label="Location"
                                  name="location"
                                  value={manualLocation}
                                  onChange={(e) =>
                                    setManualLocation(e.target.value)
                                  }
                                  maxLength={100}
                                  required
                                />
                              )}
                            </Col>
                          </Row>
                        ) : null}
                        <Row className="row mb-3 mt-3">
                          {!isManualEntry ? (
                            <Col md={12}>
                              <TextInput
                                label="Address Line 1"
                                name="AddressLine1"
                                value={addressDetails.providerAddress}
                                disabled
                                maxLength={100}
                                required
                              />
                            </Col>
                          ) : (
                            <Col md={12}>
                                <TextInput
                                  label="Address Line 1"
                                  name="AddressLine1"
                                  value={manualAddress}
                                  onChange={(e) =>
                                    setManualAddress(e.target.value)
                                  }
                                  maxLength={100}
                                  required
                                />
                            </Col>
                          )}
                        </Row>
                        {!isManualEntry && (
                          <Row className="row mb-3">
                            {["City", "State", "Country", "Zip"].map(
                              (field) => {
                                const value =
                                  addressDetails[
                                    field.toLowerCase() as keyof typeof addressDetails
                                  ];

                                const isDisabled = !suggestionSelected || !!suggestionFilled[field.toLowerCase() as keyof typeof suggestionFilled];
                                return (
                                  <Col md={3} key={field}>
                                    <TextInput
                                      label={field}
                                      name={field}
                                      value={value}
                                      maxLength={field === "State" && !isDisabled ? 3 : field === "Zip" && !isDisabled ? 10 : 100}
                                      required
                                      onChange={(e) => {
                                        const newValue = field === "Zip" ? e.target.value.replace(/\D/g, "") : e.target.value;
                                        setAddressDetails((prev: any) => ({ ...prev, [field.toLowerCase()]: newValue }));
                                      }}
                                      disabled={isDisabled}
                                    />
                                  </Col>
                                );
                              },
                            )}
                          </Row>
                        )}
                        {isManualEntry && (
                          <>
                            <Row className="mb-3 mt-3 loc-details">
                              <Col md={3}>
                                <SearchableAddressDropdown
                                  label="City"
                                  value={manualCity}
                                  options={cityOptions}
                                  onSearch={handleSearch}
                                  onSelect={(val) => setManualCity(val)}
                                  required={true}
                                  disabled={!isManualLocation}
                                />
                              </Col>
                              <Col md={3}>
                                <SearchableAddressDropdown
                                  label="State"
                                  value={manualState}
                                  options={stateOptions}
                                  onSearch={handleSearch}
                                  onSelect={(val) => setManualState(val)}
                                  required={true}
                                  disabled={
                                    (!manualCity && !manualZip) ||
                                    stateOptions.length === 1 ||
                                    !isManualLocation
                                  }
                                />
                              </Col>
                              <Col md={3}>
                                <SearchableAddressDropdown
                                  label="Country"
                                  value={manualCountry}
                                  options={countryOptions}
                                  onSearch={handleSearch}
                                  onSelect={(val) => setManualCountry(val)}
                                  required={true}
                                  disabled
                                />
                              </Col>
                              <Col md={3}>
                                <SearchableAddressDropdown
                                  label="Zip"
                                  value={manualZip}
                                  options={zipOptions}
                                  onSearch={handleSearch}
                                  onSelect={(val) => setManualZip(val)}
                                  required={true}
                                  disabled={!isManualLocation}
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                      </>
                    )}

                    {clientResult?.employerName?.length > 0 && (
                      <>
                        {clinicDetailFormAccordion([
                          {
                            title: "Contact Details",
                            content: (
                              <>
                                <div>
                                  <Row>
                                    <Col
                                      sm={3}
                                      className="d-flex align-items-center py-2"
                                    >
                                      <span className="material-symbols-outlined mx-1 text-secondary">
                                        home_health
                                      </span>
                                      Location
                                    </Col>
                                    <Col
                                      sm={3}
                                      className="d-flex align-items-center"
                                    >
                                      <span className="material-icons mx-1 text-secondary">
                                        account_balance
                                      </span>
                                      Address
                                    </Col>
                                    <Col
                                      sm={6}
                                      className="d-flex align-items-center"
                                    >
                                      <span className="material-icons mx-1 text-secondary">
                                        restart_alt
                                      </span>
                                      Communication Details
                                    </Col>
                                    <Col sm={12}>
                                      <EmployerDetailsCard
                                        employerDetails={clientResult}
                                        isViewScheduleCalender={true}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </>
                            ),
                          },
                        ])}
                      </>
                    )}
                    {showAddClinic && (
                      <>
                        {addcomDetailAccordion([
                          {
                            title: "Additional Communication Details",
                            content: (
                              <>
                                <Row>
                                  <Col sm={4}>
                                    <TagComponent
                                      label="Email Address"
                                      value={emailAddress}
                                      onChange={setEmailAddress}
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TagComponent
                                      label="Phone No"
                                      value={phoneNumber}
                                      onChange={(newValues) =>
                                        setPhoneNumber(newValues.map(String))
                                      }
                                      isPhoneOrFax={true}
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <TagComponent
                                      label="Fax No"
                                      value={faxNumber}
                                      onChange={(newValues) =>
                                        setFaxNumber(newValues.map(String))
                                      }
                                      isPhoneOrFax={true}
                                    />
                                  </Col>
                                </Row>
                              </>
                            ),
                          },
                        ])}
                      </>
                    )}
                  </>
                ),
              },
            ])}
          </Row>
        )}
        <Row className="mt-3">
          <Col sm={3} className="selection_dropdown">
            <SearchableSingleSelectDropdown
              label="Exam Type"
              name="type"
              required
              options={appointmentTypeOptions}
              value={appointmentType}
              onChange={(e, name, value) => setAppointmentType(value)}
            />
          </Col>
          <Col sm={3} className="selection_dropdown">
            <SearchableSingleSelectDropdown
              label="Medical Assistant"
              name="medicalAssistant"
              options={medicalAssistanceOptions}
              value={medicalAssistance}
              onChange={(e, name, value) => setMedicalAssistance(value)}
              disabled={
                !isScheduleAppointmentView &&
                Object.keys(patientDetailsList || {})?.length === 0
              }
            />
          </Col>
          <Col sm={3}>
            <TextInput
              label="Appointment Number"
              name="appointmentNumber"
              value={appointmentNumber}
              onChange={(e) => {
                const inputValue = e.target.value;
                const validPattern = /^[A-Za-z0-9-/]*$/;

                if (inputValue?.length <= 15 && validPattern.test(inputValue)) {
                  setAppointmentNumber(inputValue);
                }
              }}
              maxLength={15}
            />
          </Col>
          <Col sm={3} className="selection_dropdown">
            <SearchableSingleSelectDropdown
              label="Status"
              name="status"
              required
              options={appointmentStatusOptions}
              value={
                appointmentStatus ||
                appointmentStatusOptions?.find(
                  (item) => item.label === "Scheduled",
                )?.value
              }
              onChange={(e, name, value) => setAppointmentStatus(value)}
              disabled
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col sm={6}>
            <div className="d-flex gap-3 mt-2">
              <label className="me-2 fw-bold">
                Medical Exam <span style={{ color: "red" }}>*</span>
              </label>
              {medicalExamOptions?.map((option) => (
                <label key={option.value}>
                  <input
                    type="radio"
                    name="ismedicalExam"
                    value={option.value}
                    checked={ismedicalExam === option.value}
                    onChange={() => setIsMedicalExam(option.value)}
                  />
                  <span className="ms-1">{option.label}</span>
                </label>
              ))}
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col sm={12}>
            <MultilineTextBox
              label="Reason For Visit"
              name="reasonForVisit"
              value={reasonForVisit ?? ""}
              onChange={(e) => {
                let value = e.target.value;
                if (value.startsWith(" ")) return;
                value = value?.trimStart();
                value = value.replace(/ {2,}/g, " ");
                setReasonForVisit(value);
              }}
              maxLength={100}
            />
          </Col>
        </Row>
        <Row className="mb-0 mt-3">
          <Col sm={6} className="d-flex align-items-center">
            <div className="d-flex align-items-center gap-3">
              <label className="me-2 fw-bold">
                Interpreter Required <span style={{ color: "red" }}>*</span>
              </label>

              <label className="d-flex align-items-center">
                <input
                  type="radio"
                  name="interpreterRequired"
                  checked={isInterpreterReq === true}
                  onChange={() => setIsInterpreterReq(true)}
                  className="me-1"
                />
                Yes
              </label>

              <label className="d-flex align-items-center">
                <input
                  type="radio"
                  name="interpreterRequired"
                  checked={isInterpreterReq === false}
                  onChange={() => {
                    setIsInterpreterReq(false);
                    setVendor(null);
                    setLanguageNeed(null);
                    setShowAddInterpreter(false);
                    setSelectedOptionForInterpreter(null);
                    setInterpreterDetailsName("");
                    setInterpreterDetailsPhoneNo([]);
                    setInterpreterDetailsCertiNo("");
                    setSearchQueryForInterpreter("");
                  }}
                  className="me-1"
                />
                No
              </label>
            </div>
          </Col>
          {isInterpreterReq === true ? (
            <>
              <Col sm={6} className="selection_dropdown">
                <SearchableSingleSelectDropdown
                  label="Language Needs"
                  name="languageNeed"
                  required
                  options={languageNeedOptions}
                  value={languageNeed}
                  onChange={(e, name, value) => {
                    setLanguageNeed(value);
                    const selectedOption = languageNeedOptions.find(
                      (option) => option.value === value,
                    );
                    setLanguageNeedLabel(selectedOption?.label || "");
                  }}
                />
              </Col>
            </>
          ) : (
            ""
          )}
        </Row>
        {isInterpreterReq && (
          <Row className="mb-0 mt-3">
            <>
              {interpreterDetailAccordion([
                {
                  title: "Interpreter Details",
                  content: (
                    <>
                      <Row>
                        <Col md={9}>
                          <div className="form-floating" ref={dropdownRef}>
                            <input
                              type="text"
                              name="Enter Interpreter Name"
                              className="form-control zipcodeDetailsOverlay"
                              placeholder="Enter Interpreter Name"
                              maxLength={50}
                              disabled={showAddInterpreter}
                              value={searchQueryForInterpreter}
                              onChange={handleSearchChangeForInterpreter}
                              autoComplete="off"
                              required
                            />
                            <label>
                              Enter Interpreter Name
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            {filteredResultsForInterpreter.length > 0 && (
                              <div className="dropdown-results">
                                <ul
                                  className="list-group"
                                  style={{
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {/* Header */}
                                  <li
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                    style={{
                                      fontWeight: "bold",
                                      backgroundColor: "#f8f9fa",
                                    }}
                                  >
                                    <div style={{ width: "10%" }}>Select</div>
                                    <div style={{ width: "30%" }}>
                                      Interpreter Name
                                    </div>
                                    <div style={{ width: "20%" }}>
                                      Phone Number
                                    </div>
                                    <div style={{ width: "20%" }}>
                                      Certificate Number
                                    </div>
                                  </li>

                                  {filteredResultsForInterpreter.map(
                                    (option) => (
                                      <li
                                        key={option.interpreterName}
                                        className="list-group-item d-flex justify-content-between align-items-center"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleSelectInterpreterDropdown(
                                            option,
                                          )
                                        }
                                      >
                                        <div style={{ width: "10%" }}>
                                          <input
                                            type="radio"
                                            name="location"
                                            checked={
                                              selectedOptionForInterpreter?.interpreterName ===
                                              option.interpreterName
                                            }
                                            onChange={() =>
                                              handleSelectInterpreterDropdown(
                                                option,
                                              )
                                            }
                                          />
                                        </div>
                                        <div style={{ width: "30%" }}>
                                          {option.interpreterName}
                                        </div>
                                        <div style={{ width: "20%" }}>
                                          {option.interpreterPhoneNumber}
                                        </div>
                                        <div style={{ width: "20%" }}>
                                          {option.interpreterCertificateNumber}
                                        </div>
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}
                          </div>
                        </Col>

                        <Col sm={3}>
                          <div className="d-flex align-items-center mb-3 mt-3">
                            <Form.Switch
                              id="show-previous-contacts"
                              label="Add Interpreter"
                              checked={showAddInterpreter}
                              onChange={() => {
                                setShowAddInterpreter(!showAddInterpreter);
                                setIsShowInterpreter(!showAddInterpreter);
                                setFilteredResultsForInterpreter([]);
                                setSelectedOptionForInterpreter(null);
                                setInterpreterDetailsName("");
                                setInterpreterDetailsPhoneNo([]);
                                setInterpreterDetailsCertiNo("");
                                setSearchQueryForInterpreter("");
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      {isshowInterpreter && (
                        <Row>
                          <Col sm={3}>
                            <TextInput
                              label="Interpreter Name"
                              value={interpreterDetailsName}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (value.startsWith(" ")) return;
                                value = value.replace(/\s{2,}/g, " ");
                                setInterpreterDetailsName(value);
                              }}
                              maxLength={100}
                              required
                            />
                          </Col>
                          <Col sm={6}>
                            <TagComponent
                              label="Phone Number"
                              value={interpreterDetailsPhoneNo}
                              onChange={(newValues) =>
                                setInterpreterDetailsPhoneNo(
                                  newValues.map(String),
                                )
                              }
                              isPhoneOrFax={true}
                              required
                            />
                          </Col>
                          <Col sm={3}>
                            <TextInput
                              label="Certificate Number"
                              value={interpreterDetailsCertiNo}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (value.startsWith(" ")) return;
                                value = value.replace(/\s{2,}/g, " ");
                                const validPattern = /^[A-Za-z0-9-/]*$/;
                                if (validPattern.test(value)) {
                                  setInterpreterDetailsCertiNo(value);
                                }
                              }}
                              maxLength={20}
                              required
                            />
                          </Col>
                        </Row>
                      )}
                    </>
                  ),
                },
              ])}
            </>
          </Row>
        )}
        <Row className="mb-0 mt-3">
          <>
            {injuryDetailAccordion([
              {
                title: "Injury Details",
                content: (
                  <>
                    <Row>
                      <Col sm={4} className="selection_dropdown">
                        <SearchableMultiSelectDropdown
                          label="Injury"
                          name="injury"
                          options={injuryOptions}
                          values={injury}
                          onChange={(e, name, selectedValues) =>
                            handleInjuryChange(selectedValues)
                          }
                          required
                          disabled={
                            !isScheduleAppointmentView &&
                            Object.keys(patientDetailsList || {})?.length === 0
                          }
                        />
                      </Col>
                      {injury &&
                        selectedInjuryDetails?.map((inj, index) => (
                          <Col
                            key={index}
                            xs={12}
                            sm={6}
                            md={4}
                            lg={4}
                            className="record_listbox fade-in-left"
                          >
                            <Card className="h-100 shadow-sm border-0 card_rec">
                              <Card.Body className="p-0 rec_data_listaa">
                                <div className="d-flex p-2">
                                  <span className="title_tt">Injury Type</span>
                                  <TextWithTooltip
                                    text={String(inj?.injuryType)}
                                    className="rec_output"
                                  />
                                </div>
                                <div className="d-flex p-2">
                                  <span className="title_tt">Claim No</span>
                                  <TextWithTooltip
                                    text={String(inj?.claimNo)}
                                    className="rec_output rec_output"
                                  />
                                </div>
                                <div className="d-flex p-2">
                                  <span className="title_tt">
                                    Date of Incident
                                  </span>
                                  <TextWithTooltip
                                    text={String(inj?.dateOfIncident)}
                                    className="rec_output rec_output"
                                  />
                                </div>
                                <div className="d-flex p-2">
                                  <span className="title_tt">
                                    Insurance Carrier
                                  </span>
                                  <TextWithTooltip
                                    text={String(inj?.insuranceCarrier)}
                                    className="rec_output rec_output"
                                  />
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                    </Row>
                  </>
                ),
              },
            ])}
          </>
        </Row>

        <Row className="mb-3 mt-3">
          <Col className="d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleCancelButton}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="d-flex align-items-center ml-2"
              onClick={handleSubmit}
            >
              <span className="material-icons mx-1">save</span> Save
            </Button>
          </Col>
        </Row>
        <Modal show={showModalNew} onHide={handleCloseModalNew}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalNew}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancelButton}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};
export default QMEScheduleOnCalenderView;
